import { ActionTree } from "vuex";
import AvailabilityApi from "@/api/AvailabilityApi";
import { handleCommonApiErrors } from "@/api/CommonApiErrorHandler";
import { IAvailability, IAvailabilityRequest, IRootState } from "@iloq/shared";

const availabilityApi = new AvailabilityApi();

const actions: ActionTree<IRootState, IRootState> = {
  getAvailabilities(
    { state },
    availabilityRequest: IAvailabilityRequest,
  ): Promise<IAvailability[] | void> {
    return availabilityApi.getAvailabilities(availabilityRequest).catch(handleCommonApiErrors);
  },
};

export const productAvailability = {
  actions,
  state: {},
  namespaced: true,
};
